var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 215.891,
    height: 13.5,
    viewBox: "0 0 215.891 13.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3771",
    "data-name": "Group 3771",
    transform: "translate(-613.75 -2987.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3769",
    "data-name": "Group 3769",
    transform: "translate(614 2988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16011_00000096751150434044969400000001718751135152081283_",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3854",
    "data-name": "Path 3854",
    d: "M191.425-382.049H-21.966a1,1,0,0,0-1,1v11a1,1,0,0,0,1,1H191.425a1,1,0,0,0,1-1v-11A1,1,0,0,0,191.425-382.049Z",
    transform: "translate(22.966 382.049)",
    fill: "none",
    stroke: "#c4c4c4",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3855",
    "data-name": "Path 3855",
    d: "M190.925-381.549H-21.466a1,1,0,0,0-1,1v10a1,1,0,0,0,1,1H190.925a1,1,0,0,0,1-1v-10A1,1,0,0,0,190.925-381.549Z",
    transform: "translate(22.966 382.049)",
    fill: "none",
    stroke: "#c4c4c4",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_16012_00000157277003719820153030000018067131334541819275_",
    d: "M79.185,36H23.932a.5.5,0,0,0-.5.5v2a.5.5,0,0,0,.5.5H79.185a.5.5,0,0,0,.5-.5v-2A.5.5,0,0,0,79.185,36Z",
    transform: "translate(-16.356 -31)",
    fill: "#1f70b7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_53846_00000155116042923695803950000006861191667415481244_",
    transform: "translate(199.902 4.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3856",
    "data-name": "Path 3856",
    d: "M220.34,39.573a.507.507,0,0,0,.361-.152l3.086-3.155a.253.253,0,0,0,0-.357l-.361-.353a.253.253,0,0,0-.357,0l-2.725,2.786-2.724-2.786a.253.253,0,0,0-.357,0l-.361.353a.253.253,0,0,0,0,.357l3.085,3.155A.507.507,0,0,0,220.34,39.573Z",
    transform: "translate(-216.821 -35.483)",
    fill: "#616160"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabSelection);
export default __webpack_public_path__ + "static/media/TabSelection.1c4dba35cc96c2a0d111b77431d24f72.svg";
export { ForwardRef as ReactComponent };